import { useEffect } from 'react'

const SITE = 'https://schedulesmcp.com'

// Per-route <title>, meta description, and canonical for the SPA. Cloudflare Pages rewrites /* to the
// single index.html, so without this every route inherits the homepage title/description AND a
// homepage canonical — the latter tells crawlers /compare, /mcp, /pricing are all duplicates of /,
// which blocks per-route indexing. We set a SELF-referential canonical (SITE + current path; matches
// sitemap.xml) so each route indexes separately. Restores previous values on unmount.
export function usePageMeta(title: string, description?: string) {
  useEffect(() => {
    const prevTitle = document.title
    document.title = title
    const meta = description ? document.querySelector('meta[name="description"]') : null
    const prevDesc = meta?.getAttribute('content') ?? null
    if (meta && description) meta.setAttribute('content', description)

    const path = window.location.pathname
    const canonical = SITE + (path === '/' ? '/' : path)
    let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]')
    const created = !link
    if (!link) {
      link = document.createElement('link')
      link.rel = 'canonical'
      document.head.appendChild(link)
    }
    const linkEl = link
    const prevHref = linkEl.getAttribute('href')
    linkEl.setAttribute('href', canonical)

    return () => {
      document.title = prevTitle
      if (meta && prevDesc != null) meta.setAttribute('content', prevDesc)
      if (created) linkEl.remove()
      else if (prevHref != null) linkEl.setAttribute('href', prevHref)
    }
  }, [title, description])
}
